import React, { useEffect, useState } from 'react';
import qboStyles from './Qbo.styles';
import QboInstruction from './QboInstruction';
import { INTEGRATION_CONSTANTS, QBO_LOADING_STATES, QBO_LOADING_STATES_MESSAGE_MAP } from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { getQboUrl, connectToQbo, disconnectToQbo, getChartOfAccounts, getFormAndTaxYearList } from './QboSaga';
import { componentKey } from './QboSlice';
import Button from '../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';
import { useSearchParams } from 'react-router-dom';
import RichGrid from '../../../../components/richgrid/RichGrid';
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import Checkbox from '../../../../components/checkbox/basecheckbox/Checkbox';
import QboMatchFields from './QboMatchFields';
import Loadable from '../../../../components/loadable/Loadable';
import Breadcrumbs from '../../../../components/breadcrumbs/Breadcrumbs';
import { INTEGRATION_ROUTES } from '../../../constants/constants';


export default function Qbo() {
    useGarbageCollector(componentKey);
    const [taxYearOptions, setTaxYearOptions] = useState([]);
    const [formOptions, setFormOptions] = useState([]);
    const [taxYearMap, setTaxYearMap] = useState({});
    const [selectedFormMap, setSelectedFormMap] = useState({});
    const [selectedJEMap, setSelectedJEMap] = useState({});
    const [selectedIAVMap, setSelectedIAVMap] = useState({});
    const [selectedForm, setSelectedForm] = useState("");
    const [selectedTaxYear, setSelectedTaxYear] = useState("");
    const [selectedRealmId, setSelectedRealmId] = useState("");
    const [data, setData] = useState([]);
    const [queryParams, setQueryParams] = useSearchParams();
    const { qboAuthorizationUrl, businessList, chartOfAccounts, formAndTaxYearList, loadingState } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();


    useEffect(() => {
        if (qboAuthorizationUrl) {
            window.location.href = qboAuthorizationUrl;
        }
    }, [qboAuthorizationUrl]);

    useEffect(() => {
        dispatch(getFormAndTaxYearList());
    }, []);

    useEffect(() => {
        if (formAndTaxYearList) {
            setTaxYearOptions(formAndTaxYearList.TaxYear);
            setFormOptions(formAndTaxYearList.FormType);
        }
    }, [formAndTaxYearList]);

    useEffect(() => {
        if (queryParams.has(INTEGRATION_CONSTANTS.URL_CODE) && queryParams.has(INTEGRATION_CONSTANTS.REALME_ID)) {
            const qboToken = queryParams.get(INTEGRATION_CONSTANTS.URL_CODE);
            const realmId = queryParams.get(INTEGRATION_CONSTANTS.REALME_ID);
            dispatch(connectToQbo({
                qboSearchParams: {
                    Code: qboToken,
                    RealmId: realmId
                }
            }));
            queryParams.delete(INTEGRATION_CONSTANTS.URL_CODE);
            queryParams.delete(INTEGRATION_CONSTANTS.REALME_ID);
            if (queryParams.has(INTEGRATION_CONSTANTS.URL_STATE)) {
                queryParams.delete(INTEGRATION_CONSTANTS.URL_STATE);
            }
            setQueryParams(queryParams);
        }
        else if (queryParams.has(INTEGRATION_CONSTANTS.URL_ERROR)) {
            queryParams.delete(INTEGRATION_CONSTANTS.URL_ERROR);
            if (queryParams.has(INTEGRATION_CONSTANTS.URL_STATE)) {
                queryParams.delete(INTEGRATION_CONSTANTS.URL_STATE);
            }
            setQueryParams(queryParams);
        }
        else {
            dispatch(connectToQbo({
                qboSearchParams: {
                    Code: '',
                    RealmId: ''
                }
            }));
        }

    }, []);

    const handleDisconnect = (realmId) => {
        if (realmId) {
            dispatch(disconnectToQbo({
                removedrealmId: realmId,
                initialState: businessList
            }));
        }
        else {
            dispatch(addNotifications({
                heading: "Required field missing",
                message: "Please choose a realmId to proceed"
            }));
        }
    };
    const handleImport = (realmId) => {
        if (realmId && selectedFormMap[realmId] && taxYearMap[realmId]) {
            dispatch(getChartOfAccounts({
                qboRequestDto: {
                    RealmId: realmId,
                    FormName: selectedFormMap[realmId],
                    TaxYear: taxYearMap[realmId],
                    IsJournalEntry: selectedJEMap[realmId] ?? false,
                    IsInactiveVendor: selectedIAVMap[realmId] ?? false

                }
            }));
            setSelectedForm(selectedFormMap[realmId])
            setSelectedTaxYear(taxYearMap[realmId])
            setSelectedRealmId(realmId)
        }
        else {
            dispatch(addNotifications({
                heading: "Required field missing",
                message: "Please choose a TaxYear and Formtype to proceed"
            }));
        }
    };


    const gridColumns = [
        {
            header: 'Companies Name',
            renderLogic: (row, idx) => (
                <div style={qboStyles.gridRecordsMargin}>
                    <span>{row.BusinessName}</span>
                </div>
            )
        },
        {
            header: 'Tax Year',
            renderLogic: (row, idx) => (
                <div style={qboStyles.gridRecordsMargin}>
                    <SelectDropdown
                        label=""
                        placeHolder="Select taxYear"
                        name="taxYear"
                        value={{ label: taxYearMap[row.RealmId] || '', value: taxYearMap[row.RealmId] || '' }}
                        onSelectCb={(name, selectedOption) => setTaxYearMap(prevState => ({
                            ...prevState,
                            [row.RealmId]: selectedOption.value
                        }))}
                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                        options={taxYearOptions}
                        dropdownMenuStyle={qboStyles.dropdownWidth}
                        dropdownContainerStyles={qboStyles.dropdownWidth}
                    />
                </div>
            )
        },
        {
            header: 'Form Type',
            renderLogic: (row, idx) => (
                <div style={qboStyles.gridRecordsMargin}>
                    <SelectDropdown
                        label=""
                        placeHolder="Select Form"
                        name="selectedForm"
                        value={{ label: selectedFormMap[row.RealmId] || '', value: selectedFormMap[row.RealmId] || '' }}
                        onSelectCb={(name, selectedOption) => setSelectedFormMap(prevState => ({
                            ...prevState,
                            [row.RealmId]: selectedOption.value
                        }))}
                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                        options={formOptions}
                        dropdownMenuStyle={qboStyles.dropdownWidth}
                        dropdownContainerStyles={qboStyles.dropdownWidth}
                    />
                </div>
            )
        },
        {
            header: 'Journal Entry',
            renderLogic: (row, idx) => (
                <div style={qboStyles.gridcheckboxRecordsMargin}>
                    <Checkbox
                        checked={selectedJEMap[row.RealmId]}
                        onChangeCb={(e) => setSelectedJEMap(prevState => ({
                            ...prevState,
                            [row.RealmId]: e.target.checked ? true : false
                        }))}
                    />
                </div>
            )
        },
        {
            header: 'Inactive Vendor',
            renderLogic: (row, idx) => (
                <div style={qboStyles.gridcheckboxRecordsMargin}>
                    <Checkbox
                        checked={selectedIAVMap[row.RealmId]}
                        onChangeCb={(e) => setSelectedIAVMap(prevState => ({
                            ...prevState,
                            [row.RealmId]: e.target.checked ? true : false
                        }))}
                    />
                </div>
            )
        },
        {
            header: 'Actions',
            renderLogic: (row, idx) => (
                <div style={qboStyles.gridRecordsMargin}>
                    <Button
                        type={BUTTON_TYPE.PRIMARY}
                        title="Import"
                        onClickCb={() => handleImport(row.RealmId)}

                    >
                        Import
                    </Button>
                    <Button
                        type={BUTTON_TYPE.PRIMARY}
                        title="Disconnect"
                        onClickCb={() => handleDisconnect(row.RealmId)}
                        style={qboStyles.gridButtonGap}
                    >
                        Disconnect
                    </Button>
                </div>
            )
        }
    ];
    useEffect(() => {
        const fetchData = () => {
            const formattedData = businessList.map(business => ({
                BusinessName: business.Text,
                RealmId: business.Value
            }));
            setData(formattedData);
        };

        fetchData();
    }, [businessList]);

    const breadcrumbItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
        { text: 'Qbo' }
    ];

    return (
        <>
            <Breadcrumbs items={breadcrumbItems} />
            {
                chartOfAccounts.length === 0 ?
                    (
                        <div style={qboStyles.container}>
                            <div style={qboStyles.marginBottomStyle}>
                                <QboInstruction />
                            </div>
                            <Loadable
                                currentState={loadingState.state}
                                loadingStates={QBO_LOADING_STATES.GRID_LOADING}
                                messageMap={QBO_LOADING_STATES_MESSAGE_MAP}
                                isNewLoadable={true}
                            >
                                {businessList && (

                                    <RichGrid
                                        columns={gridColumns}
                                        data={data}
                                    />
                                )}

                                <div style={qboStyles.marginBottomStyle}>
                                    <Button
                                        type={BUTTON_TYPE.PRIMARY}
                                        title="Connect to QBO"
                                        onClickCb={() => dispatch(getQboUrl())}
                                    >
                                        {businessList ? "Add New Company" : "Connect to QBO"}
                                    </Button>
                                </div>
                            </Loadable>
                        </div>
                    ) :
                    (
                        <QboMatchFields qboCOAOptions={chartOfAccounts} formType={selectedForm} taxYear={selectedTaxYear} realmId={selectedRealmId} ></QboMatchFields>
                    )
            }
        </>
    );
}